import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  ASSETS_ADMIN_ROLES,
  ASSETS_ALL_ROLES,
  ROUTE_ASSETS,
} from "../../SharedModule/utils/constants";
import { Spinner } from "../../SharedModule/components/Spinner";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";

export const AssetsListPage = () => {
  const auth = useSelector(selectAuth);
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
  };
  const dispatch = useDispatch();

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - Assets";
    dispatch(setActiveTab(ROUTE_ASSETS));
  }, []);

  const addAsset = () => {
    const newWindow = window.open(
      process.env.REACT_APP_APPSMITH_ASSETS_LIST_PAGE,
      "_blank"
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  const couldAddEditAsset = verifyModuleAccess(
    true,
    ASSETS_ADMIN_ROLES,
    userRolesList
  );

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) && (
          <ForbiddenPage />
        )}

      {rolesLoaded &&
        verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) && (
          <TelerikReport
            title="Asset List"
            reportName="AssetList.trdp"
            parameters={parameters}
            parametersAreaVisible={false}
            buttonAction={couldAddEditAsset ? addAsset : undefined}
            buttonActionLabel={couldAddEditAsset ? "New Asset" : undefined}
          />
        )}
    </>
  );
};
